import * as Yup from "yup";

export const LISTING_TEMPLATE_EDIT_FORM_SCHEMA = Yup.object().shape({
  name: Yup.string().trim().required("Naziv predloška je obavezan"),
  titleTemplate: Yup.string().trim().required("Naslov oglasa je obavezan"),
});
